<div class="container" [ngClass]="{ positive: isPositive, negative: !isPositive, filled: filled }">
    <qtm-typography fontWeight="bold" fontSize="9">
        <ng-content></ng-content>
    </qtm-typography>
</div>
